import { createSlice } from '@reduxjs/toolkit';

const bannerSlice = createSlice({
  name: 'banner',
  initialState: { isOpen: false },
  reducers: {
    toggleBanner: (state) => {
      state.isOpen = !state.isOpen;
    },
    closeBanner: (state) => {
      state.isOpen = false;
    },
    openBanner: (state) => {
      state.isOpen = true;
    },
  },
});

export const { toggleBanner, closeBanner, openBanner } = bannerSlice.actions;
export default bannerSlice.reducer;
